import React from 'react';
import styled from '@emotion/styled';
import { TourTrashUserType } from '../../../../types/tourtrash';

interface Props {
  record: TourTrashUserType;
}

export default React.memo((props: Props) => {
  const { record } = props;
  return (
    <StyledContainer>
      <span>{record?.spentAmount || 'N/A'}</span>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  padding-left: 0.5rem;
`;
